export default __webpack_public_path__ + "static/icon-11-2-830619d4cedd49eeda54e0a5e09be245.png";